<template>
  <div>
    <ContainerBasic classes="max-w-screen-lg mx-auto">
      <div class="text-center">
        <div v-if="event.price && event.price > 0" class="text-3xl font-bold">
          <div>
            {{
              t('event.cta.heading', {
                price: n(
                  event.price,
                  event.price % 1 === 0 ? 'currencyNoCents' : 'currency',
                ),
              })
            }}
          </div>
          <div class="text-sm font-normal">
            {{
              event.isGroupPrice
                ? t('event.tax.prefix.group')
                : t('event.tax.prefix.person')
            }}
            {{ t('event.tax') }}
          </div>
        </div>
        <div v-else class="text-2xl font-bold">
          {{ t('event.cta.heading' + priceTranslationKey) }}
        </div>
        <div class="text-sm">
          {{ blockData.text }}
        </div>
        <ButtonBasic
          :label="t('event.cta.title' + priceTranslationKey)"
          :btn-style="EButtonStyle.CTA"
          :slim="true"
          :disabled="isDisabled"
          classes="mx-auto inline-block mt-md"
          @click="scrollToForm()"
        />
        <div v-if="isDisabled" class="mt-2 text-sm">
          {{ t(eventFull ? 'event.cta.fullyBooked' : 'event.cta.cancelled') }}
        </div>
      </div>
    </ContainerBasic>
  </div>
</template>

<script setup lang="ts">
import { EButtonStyle } from '@/@types/basic-button';
import { scrollToElement } from '@/helpers/scroll';
import { EEventStatus } from '@/@types/event-status';
import ContainerBasic from '@/components/components/container-basic.vue';
import ButtonBasic from '~~/src/components/components/core/basic-button/vdv/basic-button.vue';
import type { CTAEventData } from '../blockTypes';
import type { EventPage } from '~~/src/server/transformers/page/eventPage';
import type { EventData } from '~~/src/server/transformers/EntityTransformers/eventTransformer';

const { t, n } = useTrans();

defineProps({
  blockData: {
    type: Object as PropType<CTAEventData>,
    required: true,
  },
});

const pageData = usePageData<EventPage>();
const event = <EventData>pageData.value.event;
const eventFull = event.status === EEventStatus.FULLY_BOOKED;
const eventCancelled = event.status === EEventStatus.CANCELLED;
const isDisabled = eventCancelled || eventFull;

const scrollToForm = () => {
  if (eventFull || eventCancelled) {
    return;
  }
  const formElements = document.querySelectorAll('*[id^="FormContainer"]');
  if (formElements.length > 0) {
    scrollToElement(formElements[0]);
  }
  return;
};

const priceTranslationKey = computed(() => {
  switch (event.price) {
    case null:
      return '.notSpecified';
    case 0:
      return '.forFree';
    default:
      return '';
  }
});
</script>
